

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import router from './router/index'
import App from './App'
import './assets/css/common.css' 
import './assets/css/base.css' 
import './assets/css/style.css' 


import moment from 'moment'


import store from './vuex/store'

import utils from './common/utils' 
Vue.use(utils)

import ajaxError from './api/ajaxError' 
Vue.use(ajaxError)

import VueScroller from 'vue-scroller'

Vue.use(VueScroller)
import Carousel3d from 'vue-carousel-3d'

import vueiInfinite from 'vue-infinite-scroll'
Vue.use(vueiInfinite)

Vue.use(Carousel3d)


import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)


import 'vant/lib/index.css' 
import {
Checkbox,
CheckboxGroup,
Uploader,
Tab,
Tabs,
List
} from 'vant'
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Uploader)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)


import * as filters from './filters'

Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})

FastClick.attach(document.body)
Vue.prototype.moment = moment
Vue.prototype.toBack = () => router.back(-1) 
Vue.prototype.$bus = new Vue({}) 


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')


/*
var getCookie = function (key) {
var getCookie = document.cookie.replace(/[ ]/g, '')
var arrCookie = getCookie.split('')
var tips
for (var i = 0 i < arrCookie.length i++) {
var arr = arrCookie[i].split('=')
if (key == arr[0]) {
tips = arr[1]
break
}
}
return tips
}

router.beforeEach((to, from, next) => {
console.warn(11)
if (to.path === '/' || to.path === '/login' || to.path === '/nofind' || to.path === '/register' || to.path === '/forgetPass') {
next()
} else {
var UserToken = getCookie('UserToken')
if (UserToken) {
next()
} else {
store.commit('UPDATE_LOADING', false)
next({path: '/login'})
store.commit('SHOWTOAST','请重新登录')
}
}
})*/



// WEBPACK FOOTER //
// ./src/main.js